import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/batch/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsNCFileEventsStack = createStackNavigator();

const BatchDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <BatchDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <BatchDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </BatchDetailsNCFileEventsStack.Navigator>
  );
};

export { BatchDetailsNCFileEventsNavigator };
